import { useInventoryDatabases } from "./useDatabases";
import { useCurrentInventoryId } from "../url";
import { isType } from "../../utils/utils";
import { usePouchAllDocs } from "./usePouchAllDocs";
import { useMemo } from "react";

export function useInventoryContents() {
  const { inventory } = useInventoryDatabases();
  const { inventoryId } = useCurrentInventoryId();
  const { data, loading, error } = usePouchAllDocs(inventoryId ? [`inventory:${inventoryId}`] : [], inventory, { include_docs: true });

  /* Piano stores both geometries and forms in the same database, with different `type`s for each document (`formdata`
   * or `geometry`). But for pretty much the entire client we rather want this structured as the objects (`geometry`)
   * with their forms nested in them. This restructuring below achieves that.
   */

  const objects = useMemo(
    () =>
      data &&
      data.filter(isType("type", "geometry")).map((row) => ({
        id: row._id,
        title: row.title,
        geom: row.geom,
        data: row.data.map((dataId) => data.find((row) => row.type === "formdata" && row._id === dataId)!),
        rev: row._rev,
      })),
    [data]
  );

  return { data: objects, loading, error };
}
